import EmptyStateIllustration from "../../assets/illustrations/empty-state.svg";
import { useTranslation } from "../../i18n";
import { cn } from "../../utils";
import type { EmptyStateClasses, EmptyStateProps } from "./types";

export const EmptyState = ({
  title,
  text,
  illustration,
  actions,
  className,
  size = "md",
  showIllustration = true,
}: EmptyStateProps) => {
  const { t } = useTranslation();

  const sizeClasses: EmptyStateClasses = {
    sm: {
      illustration: "w-[160px] flex items-center justify-center",
      contentClass: showIllustration ? "mt-4" : "",
      titleClass: "text-md font-medium",
      textClass: "mt-1 text-md text-neutral-500/50",
      actionsClass: "mt-6",
    },
    md: {
      illustration:
        "w-[160px] sm:w-[200px] md:w-[240px] flex items-center justify-center",
      contentClass: showIllustration ? "mt-4 md:mt-6" : "",
      titleClass: "text-md font-medium",
      textClass: "mt-1 text-md text-neutral-500/50",
      actionsClass: "mt-6",
    },
  };

  const currentSize = sizeClasses[size];

  return (
    <div
      className={cn(
        "flex flex-col flex-1 w-full items-center justify-center",
        className,
      )}
    >
      <div className="flex flex-col items-center">
        {showIllustration && (
          <div className={currentSize.illustration}>
            {illustration || (
              <img
                src={EmptyStateIllustration}
                alt={t("emptyState.illustrationAlt")}
                className="w-full h-auto"
              />
            )}
          </div>
        )}
        <div
          className={cn("flex flex-col items-center", currentSize.contentClass)}
        >
          {title && (
            <div
              className={cn(
                "text-center text-neutral-500 font-medium",
                currentSize.titleClass,
              )}
            >
              {title}
            </div>
          )}
          {text && (
            <div
              className={cn(
                "text-center text-neutral-500",
                currentSize.textClass,
              )}
            >
              {text}
            </div>
          )}
          {actions && (
            <div
              className={cn(
                "flex items-center gap-2",
                currentSize.actionsClass,
              )}
            >
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
